import styled from 'react-emotion';
import { themeGet } from 'styled-system';
import { H4, FlexCol, FlexRow } from '../misc';

export const FieldsetWrapper = styled(FlexCol)`
  padding: ${themeGet('space.4')}px 0;
  opacity: ${props => (props.disabled ? 0.4 : 1)};
  transition: opacity 0.15s linear;
`;

export const StyledFieldset = styled('fieldset')`
  background: #fff;
  border: none;
  box-shadow: ${themeGet('shadows.tertiary')};
  border-radius: ${themeGet('radii.default')}px;
`;

export const Heading = styled(H4)`
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: ${themeGet('space.2')}px;
  text-decoration: underline;
`;

export const Label = styled('label')`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  padding: ${themeGet('space.3')}px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #f0f5fa;
  }

  span {
    min-width: 80px;
    padding: 0 ${themeGet('space.4')}px;
    text-align: left;
    font-weight: 400;
    color: ${themeGet('colors.black')};
    width: ${props => (props.withCheckbox ? '70%' : 'auto')};
  }
`;

export const CheckboxWrapper = styled(FlexRow)`
  width: 30%;
`;

const Input = styled('input')`
  padding: 0 ${themeGet('space.4')}px;
  font-weight: 300;
  font-size: 16px;
  color: ${themeGet('colors.black')};
  background: transparent;
  outline: 0;
  border: 0;
  cursor: text;
`;

export const TextInput = styled(Input)`
  flex: 1;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
`;

export const TextAreaLabel = styled(Label)`
  height: 100px;
`;

export const TextArea = styled('textarea')`
  width: 100%;
  height: 100%;
  padding: 0 ${themeGet('space.4')}px;
  font-weight: 400;
  font-size: 16px;
  color: ${themeGet('colors.black')};
  background: transparent;
  outline: 0;
  border: 0;
  cursor: text;
`;



// WEBPACK FOOTER //
// ./src/components/fieldset/style.js